import React from "react";


// import Custom Components

import MainLayout from "../layouts/MainLayout";

import PageHeader from "../components/common/page-header";
import Breadcrumb from "../components/common/breadcrumb";
import CartPage from "../components/cart";
import Seo from "../components/common/SEO";
function Cart() {

  return (
    <>
      <MainLayout>
        
      <Seo title={`${process.env.GATSBY_STORE_NAME}- Shopping Cart`} />
        <div className="main">

          <h1 className="d-none">
          {process.env.GATSBY_STORE_NAME} - Shopping Cart
          </h1>

          <div className="main">
            <PageHeader title="Shopping Cart" subTitle="Shop" />
            <Breadcrumb
              title="Shopping Cart"
              // parent1={["Shop", "shop/sidebar/list"]}
            />
            <CartPage />
          </div>
        </div>
      </MainLayout>
    </>
  );
}

export default Cart;
